//@flow
import * as React from 'react'
import type { SeleneQualityReview$Props } from './flowTypes'
import ContainerRowExpandPanel from '../../components/common/ContainerRowExpandPanel'
import QualityReviewContainer from '../../components/QualityReview/QualityReviewContainer'

const SeleneQualityReview=(props:SeleneQualityReview$Props)=>{
    const selene = props.selene
    let isVisible = false

    if (selene.reviewQuestions && selene.reviewQuestions.length > 0){
        isVisible = true
    }
    
    return (
        <ContainerRowExpandPanel visible={isVisible} 
        title={'Final Review Before Submission'} elementId={'orionQualityReview'} 
        errors={props.noOfErros}
        >
            <QualityReviewContainer 
                elementId={'orionPanelReviewQuestion'} 
                changeFieldValue={props.changeFieldValue} 
                questions={(selene.reviewQuestions:any)} 
            />
        </ContainerRowExpandPanel>
    )
}

export default SeleneQualityReview


// WEBPACK FOOTER //
// ./src/views/ProjectSelene/SeleneQualityReview.js